import { Overline, Card } from "./shared";

export const SalesResult = ({ r }) => (
  <div data-testid="bb-result-sales" className="grid grid-cols-1 lg:grid-cols-2 gap-5">
    <Card>
      <Overline>Cold emails</Overline>
      {(r.cold_emails || []).map((e) => (
        <div key={e.subject} className="mb-4 border border-black p-3 bg-[#fafafa]">
          <div className="font-bold text-sm">Subject: {e.subject}</div>
          <p className="text-xs text-[#52525b] mt-2 whitespace-pre-line">{e.body}</p>
        </div>
      ))}
      <Overline>Lead magnets</Overline>
      <ul className="space-y-1 text-sm">
        {(r.lead_magnets || []).map((l) => <li key={l}>🧲 {l}</li>)}
      </ul>
    </Card>
    <Card>
      <Overline>Sales script</Overline>
      <p className="text-sm mb-2"><b>Opening:</b> {r.sales_script?.opening}</p>
      <ul className="text-sm space-y-1 mb-2">
        {(r.sales_script?.discovery_questions || []).map((q) => <li key={q}>? {q}</li>)}
      </ul>
      <p className="text-sm mb-2"><b>Pitch:</b> {r.sales_script?.pitch}</p>
      <p className="text-sm mb-4"><b>Close:</b> {r.sales_script?.close}</p>
      <Overline>Objections</Overline>
      {(r.objections || []).map((o) => (
        <div key={o.objection} className="text-xs mb-2">
          <span className="text-[#ff3b30]">&ldquo;{o.objection}&rdquo;</span> → {o.response}
        </div>
      ))}
      <div className="font-mono text-xs text-[#52525b] mt-3">⏱ {r.follow_up_cadence}</div>
    </Card>
  </div>
);
